import React, { useCallback } from 'react';

import Waves from '../../waves';
import { Styled } from '../styled';
import { TextItem } from './text-item';

const Component = (props) => {
  const {
    element,
    elementId,
    isActive,
    borderRadius,
    onClick,
    setTooltip,
    removeTooltip,
    optionRenderer,
  } = props;
  const onItemClick = useCallback((event) => onClick(event, elementId), [onClick, elementId]);
  return (
    <Styled.DropDownItem
      borderRadius={borderRadius}
      onClick={onItemClick}
      onMouseEnter={setTooltip}
      onMouseLeave={removeTooltip}
    >
      {optionRenderer ? optionRenderer(element, isActive) : (
        <TextItem
          isActive={isActive}
        >
          {element}
        </TextItem>
      )}
      <Waves />
    </Styled.DropDownItem>
  );
};


export const Item = React.memo(Component);